import React from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";

const Header = styled.header`
  margin-bottom: 20px;
`;

const Links = styled(Link)`
  background-image: url("/Icons/arrow-up-right-circle.svg");
  background-size: 40px;
  background-position: right 20px center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  cursor: pointer;
  padding: 20px;
  box-sizing: border-box;
  background-color: #66cd7c;
  border: none;
  border-radius: 5px;
  text-align: left;
  h3 {
    color: #121212;
    font-size: 20px;
    font-weight: 800;
  }
  p {
    font-size: 14px;
    color: #121212;
  }
  span {
    font-size: 12px;
    border: 1px solid #121212;
    padding: 8px 15px;
    border-radius: 20px;
    margin-top: 10px;
  }
  @media (max-width: 600px) {
    padding: 13px;
    background-size: 30px;
    h3 {
      font-size: 16px;
      margin-bottom: 5px;
    }
    p {
      font-size: 12px;
    }
  }
`;

export default function CreateBanner({ title, description, link }) {
  const navigate = useNavigate();

  return (
    <Header>
      <Links to={link}>
        <h3>{title}</h3>
        <p>{description}</p>
      </Links>
    </Header>
  );
}
